import { render, staticRenderFns } from "./FichaAcudiente.vue?vue&type=template&id=520b4fbd&"
import script from "./FichaAcudiente.vue?vue&type=script&lang=js&"
export * from "./FichaAcudiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports